const TERMS_TEXT = `KRAYA - Merchant Waitlist Terms & Conditions

1. Purpose of Waitlist

The Kraya waitlist allows interested merchants to register their interest in using the Kraya platform, a mobile-first commerce tool designed to enable local order-to-pickup, rewards, and merchant engagement.

By signing up, you may be considered for early access during the trial and testing phase of the Kraya Merchant App.

2. Eligibility

To join the waitlist:

• You must be a store owner or an authorized representative of a business with a physical storefront in India

• You must be at least 18 years old and legally capable of entering into binding agreements

3. Trial Phase & No Guarantees

Kraya is currently in a trial and testing phase.

By joining the waitlist:

• You acknowledge that the platform is under development and may be incomplete, modified, or discontinued at any time

• Participation in the waitlist or trial does not guarantee onboarding, access, or continued use of the platform

• Kraya reserves the right, at its sole discretion, to approve, deny, limit, suspend, or revoke access to any merchant at any time, with or without notice

4. Data Collection & Use

By submitting your information, you agree that:

• Kraya may collect and store the business and contact details you provide

• Your data will be used for:

  - Waitlist management and onboarding

  - Product updates, testing communication, and operational notifications

  - Relevant marketing and feature announcements

• Kraya does not sell your personal or business data to third parties

Data will be handled in accordance with applicable Indian laws, including reasonable security practices and safeguards.

5. Referral Program (If Applicable)

Kraya may introduce referral features during the waitlist or trial phase.

• Merchants who refer other eligible businesses may be considered for early access or platform benefits

• Referral rewards, if any, are subject to verification and availability

• Kraya reserves the right to modify, suspend, or discontinue any referral program at its sole discretion

6. Data Rights & Communication

You may:

• Request access to your data

• Request correction or deletion of your data

• Opt out of non-essential communications

To exercise these rights, contact: hello@kraya.app

Kraya will take reasonable steps to respond to such requests in accordance with applicable laws.

7. Changes to Terms

Kraya reserves the right to update or modify these Terms at any time.

Updated Terms may be communicated via email or through the Kraya platform. Continued participation in the waitlist constitutes acceptance of such changes.

8. Disclaimer & Limitation of Liability

The Kraya platform, including any trial access, is provided on an "as is" and "as available" basis.

Kraya makes no warranties or representations, express or implied, regarding:

• Availability, reliability, or performance of the platform

• Suitability for any particular business purpose

To the maximum extent permitted under applicable law, Kraya shall not be liable for:

• Any business decisions made based on participation in the waitlist or trial

• Any losses, damages, or missed opportunities arising from:

  - Platform delays or downtime

  - Feature changes or removals

  - Limited or revoked access

9. Intellectual Property

All Kraya trademarks, logos, designs, product features, and content remain the exclusive property of Kraya.

Joining the waitlist or participating in the trial does not grant any right to use Kraya's intellectual property without prior written permission.

10. Governing Law & Jurisdiction

These Terms shall be governed by the laws of India, and courts in Hyderabad, Telangana shall have exclusive jurisdiction.

11. Contact

For any questions or concerns:

Email: hello@kraya.app

Consent

By submitting your business details, you confirm that:

• You have read and understood these Terms

• You agree to be part of the Kraya waitlist and trial phase`

export function downloadTerms() {
  const blob = new Blob([TERMS_TEXT], { type: 'text/plain' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = 'Kraya_Terms_and_Conditions.txt'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
